import React from "react"
import styled from 'styled-components';

const FormContentSc = styled.div`
  flex: 1 1 auto;

  .ui.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {
    font-size: 1.1rem;
    color: #373737;

    &.small {
      font-size: 1.05em;
    }
  }
`;

interface DivWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  // [key: string]: any
}

export class FormContent extends React.Component<DivWrapperProps> {
  render() {
    const {children, ...rest} = this.props;
    return <FormContentSc {...rest}>
      {children}
    </FormContentSc>;
  }
}

export default FormContent;
